import { media, font, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../utilities/create/jss.js";
import "../node_modules/postcss/lib/postcss.js";
import "../node_modules/postcss-js/index.js";
import "../node_modules/postcss-nesting/dist/index.js";
import "../_virtual/index.js";
const breakpointLarge = media.queries.large.min;
const breakpointDesktop = media.queries.desktop.min;
const base = {
  fontFamily: font.family["serif"]
};
const sizeLarger = {
  fontSize: font.size["4xl"],
  lineHeight: `1.18em`
};
const sizeLarge = {
  fontSize: font.size["3xl"],
  lineHeight: `1em`
};
const sizeMedium = {
  fontSize: font.size["xl"],
  lineHeight: `1.5em`
};
const maximumBase = {
  ...base,
  ...sizeLarger,
  [`@media (${breakpointLarge})`]: {
    fontSize: `calc(${font.size["4xl"]} + 4vw)`
  },
  [`@media (${breakpointDesktop})`]: {
    fontSize: font.size["9xl"],
    fontWeight: font.weight["light"],
    lineHeight: `1.025em`
  }
};
const extralargeBase = {
  ...base,
  ...sizeLarger,
  [`@media (${breakpointLarge})`]: {
    fontSize: `calc(${font.size["4xl"]} + 2vw)`
  },
  [`@media (${breakpointDesktop})`]: {
    fontSize: font.size["6xl"],
    lineHeight: `1.07em`
  }
};
const largerBase = {
  ...base,
  ...sizeLarge,
  [`@media (${breakpointLarge})`]: {
    fontSize: `calc(${font.size["3xl"]} + 0.66vw)`
  },
  [`@media (${breakpointDesktop})`]: {
    ...sizeLarger
  }
};
const largeBase = {
  ...base,
  ...sizeMedium,
  [`@media (${breakpointLarge})`]: {
    fontSize: `calc(${font.size["xl"]} + 0.33vw)`
  },
  [`@media (${breakpointDesktop})`]: {
    ...sizeLarge
  }
};
const mediumBase = {
  ...base,
  ...sizeMedium
};
function compose(size, options) {
  const { theme, color: explicitColor } = options || {};
  const sizes = {
    maximum: maximumBase,
    extralarge: extralargeBase,
    larger: largerBase,
    large: largeBase,
    medium: mediumBase
  };
  const base2 = sizes[size];
  const finalColor = explicitColor || (theme === "dark" ? color.white : color.black);
  const composed = {
    ...base2,
    ...theme && {
      color: finalColor
    }
  };
  const classNameParts = ["umd-serif", size];
  if (theme === "dark") classNameParts.push("dark");
  return objectWithClassName({
    ...composed,
    className: classNameParts.join("-")
  });
}
const maximum = compose("maximum");
const extralarge = compose("extralarge");
const larger = compose("larger");
const large = compose("large");
const medium = compose("medium");
const fonts = {
  maximum: compose("maximum"),
  extraLarge: compose("extralarge"),
  larger: compose("larger"),
  large: compose("large"),
  medium: compose("medium")
};
export {
  compose,
  extralarge,
  fonts,
  large,
  larger,
  maximum,
  medium
};
//# sourceMappingURL=serif.js.map
